// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ShareLink: React.FC<{ width?: number; height?: number }> = ({ width = 12, height = 11 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 11">
            <path
                fill="currentColor"
                d="M7.21875,0.0387836462 C6.9375,0.157411529 6.75,0.442118447 6.75,0.750550942 L6.75,2.64859706 L4.125,2.64859706 C1.8515625,2.64859706 0,4.52291761 0,6.82429853 C0,9.50528868 1.921875,10.7152931 2.34375,10.9525488 C2.4140625,11 2.484375,11 2.53125,11 C2.7890625,11 3,10.7864698 3,10.5254885 C3,10.3594094 2.90625,10.1933304 2.765625,10.0747025 C2.5546875,9.86117233 2.25,9.43411195 2.25,8.72234465 C2.25,7.4648891 3.2578125,6.44468931 4.5,6.44468931 L6.75,6.44468931 L6.75,8.34273543 C6.75,8.65116792 6.9375,8.93587484 7.21875,9.05450273 C7.5,9.17313061 7.828125,9.10195388 8.0390625,8.88842369 L11.7890625,5.09233145 C12.0703125,4.78389895 12.0703125,4.30938742 11.7890625,4.0246805 L8.0390625,0.228588258 C7.828125,-0.00866750682 7.5,-0.0561186599 7.21875,0.0625092228 L7.21875,0.0387836462 Z"
            />
        </svg>
    );
};

export default React.memo(ShareLink);
